import styled from 'styled-components';

export const StyledPanel = styled.div`
  width: 312px;

  .ant-picker-panel,
  .ant-picker-date-panel,
  .ant-picker-year-panel,
  .ant-picker-month-panel,
  .ant-picker-decade-panel {
    width: 100%;

    /* Header styles */
    .ant-picker-header {
      display: grid;
      grid-template-areas:
        'superPrev superTitle superNext'
        'prev title next';
      grid-template-columns: 1fr 5fr 1fr;
      border-bottom: none;

      .ant-picker-header-super-prev-btn {
        grid-area: superPrev;
      }
      .ant-picker-header-prev-btn {
        grid-area: prev;
      }
      .ant-picker-header-super-next-btn {
        grid-area: superNext;
      }
      .ant-picker-header-next-btn {
        grid-area: next;
      }

      .ant-picker-header-view {
        display: contents;

        button:not(:first-child) {
          margin-left: 0;
        }

        .ant-picker-month-btn {
          grid-area: title;
        }
        .ant-picker-year-btn,
        .ant-picker-decade-btn {
          grid-area: superTitle;
        }
      }

      /* Icon styles */
      svg {
        color: ${({ theme }) => theme.color.theme.primary};
        font-size: 12px;
      }
    }

    /* Body styles */
    .ant-picker-body {
      width: 100%;

      table {
        width: 100%;

        td {
          padding: 0;

          div {
            display: inline;
            padding: 4px 8px;
            border-radius: 100px;
          }
        }
      }
    }
  }
`;
